// GAVION booking: the port of the public booking pages (spec §2, §4). Real: gavion-booking over fetch, no login. Demo:
// the slot engine over FakeRest (plan D19). Errors are stable codes: slot_taken may carry refreshed slots, link_expired
// the rep (or null for an unknown token, plan D10).
export type PublicLang = "fr" | "en";
export type PublicRep = { firstName: string; lastName: string; avatarUrl: string | null };
export type SlotPage = { rep: PublicRep; slots: string[]; horizonEnd: string; nextFrom: string | null };
export type SlotQuery = { slug: string; from: string; to: string } | { token: string; from: string; to: string };
export type BookInput = {
  slug: string;
  start: string;
  name: string;
  company: string;
  email: string;
  phone: string;
  /** The honeypot: always "" for a person. */
  website: string;
  lang: PublicLang;
};
export type BookResult = {
  status: "booked" | "rescheduled" | "received";
  startsAt: string | null;
  endsAt: string | null;
  manageToken: string | null;
};
export type ManageRep = { firstName: string; lastName: string; email: string };
export type ManageView = {
  status: "pending" | "booked" | "rescheduled" | "cancelled" | "failed";
  startsAt: string;
  endsAt: string;
  language: PublicLang;
  rep: ManageRep;
};
export interface PublicBookingApi {
  slots(q: SlotQuery): Promise<SlotPage>;
  book(i: BookInput): Promise<BookResult>;
  manage(token: string): Promise<ManageView>;
  reschedule(token: string, start: string): Promise<ManageView>;
  cancel(token: string): Promise<ManageView>;
}
export class PublicBookingError extends Error {
  readonly code: string;
  readonly slots: string[];
  readonly rep: ManageRep | null;
  constructor(code: string, o: { slots?: string[]; rep?: ManageRep | null } = {}) {
    super(code);
    this.name = "PublicBookingError";
    this.code = code;
    this.slots = o.slots ?? [];
    this.rep = o.rep ?? null;
  }
}
